'use client';
import { ClipboardList, PlayCircle } from 'lucide-react';
import { Trace, TraceCollapsible, TraceCollapsibleContent, TraceCollapsibleTrigger, TraceIcon, TraceLine, TraceTitle } from '../../components/ui/shadcn/trace';
import { Button } from '../../components/ui/Button';
import { useTranslation } from '../../lib/i18n';
import { useBrainChat, useBrainChatStatus } from './BrainChatProvider';
import { ChatMarkdown } from './ChatMarkdown';

/** One submitted plan and its daemon-owned decision, in the transcript. */
export function PlanCard({ plan, id }: { plan: string; id?: string }) {
  const { t } = useTranslation();
  const { implementPlan, dismissPlan } = useBrainChat();
  const { planDecision, planSubmitting, guest } = useBrainChatStatus();
  const pending = planDecision?.id === id && planDecision !== null;
  return <Trace data-testid="chat-plan" className="my-1" aria-busy={pending && planSubmitting}>
    <TraceCollapsible defaultOpen>
      <TraceCollapsibleTrigger>
        <TraceLine><TraceIcon><ClipboardList /></TraceIcon><TraceTitle>{t.brainChat.proposedPlan}</TraceTitle></TraceLine>
      </TraceCollapsibleTrigger>
      <TraceCollapsibleContent>
        <div data-testid="plan-decision-body"><ChatMarkdown text={plan} /></div>
      </TraceCollapsibleContent>
    </TraceCollapsible>
    {/* The pending decision stays visible even when the plan text is folded. */}
    {pending && guest ? <p className="text-meta text-muted-foreground">{t.chat.ownerDecidesPlan}</p> : null}
    {pending && !guest ? <div className="flex flex-col gap-3">
      <p className="text-meta text-muted-foreground">{t.brainChat.planDecision}</p>
      <div className="flex w-full flex-wrap justify-end gap-2">
        <Button data-testid="plan-decision-refine" variant="ghost" onClick={dismissPlan} disabled={planSubmitting}>{t.brainChat.planRefine}</Button>
        <Button data-testid="plan-decision-implement" variant="accent" icon={PlayCircle} onClick={implementPlan} disabled={planSubmitting}>{t.brainChat.planImplement}</Button>
      </div>
    </div> : null}
  </Trace>;
}
